import React, { useEffect, useMemo, useState } from 'react';
import { Box, MenuItem, TextField, Typography } from '@mui/material';

/**
 * Admin-only owner selector that keeps the hidden owner field in sync with the form.
 */
const DeviceOwnerSettings = ({ isAdmin = false, disabled = false, initialOwnerId = '', ownerOptions = [], onOwnerChange = null }) => {
    const [selectedOwnerId, setSelectedOwnerId] = useState(initialOwnerId ? String(initialOwnerId) : '');

    const normalizedOwnerOptions = useMemo(() => {
        return Array.isArray(ownerOptions) ? ownerOptions : [];
    }, [ownerOptions]);

    useEffect(() => {
        const hiddenInput = document.querySelector('input[name="id_client"]');
        if (hiddenInput) {
            hiddenInput.value = selectedOwnerId;
            hiddenInput.dispatchEvent(new Event('input', { bubbles: true }));
            hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (onOwnerChange) {
            onOwnerChange(selectedOwnerId);
        }
    }, [onOwnerChange, selectedOwnerId]);

    if (!isAdmin) {
        return null;
    }

    return (
        <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" gutterBottom>
                Device Owner
            </Typography>
            <TextField
                select
                fullWidth
                size="small"
                label="Owner account"
                value={selectedOwnerId}
                onChange={(event) => setSelectedOwnerId(event.target.value)}
                disabled={disabled}
            >
                {normalizedOwnerOptions.map((owner) => (
                    <MenuItem key={owner.id} value={String(owner.id)}>
                        {owner.name} {owner.email ? `(${owner.email})` : ''}
                    </MenuItem>
                ))}
            </TextField>
        </Box>
    );
};

export default DeviceOwnerSettings;